module.exports = __webpack_public_path__ + "lazerBrochure.webp?dc1fbac954c8c2c2f4661028b7158deb";